import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { LocalExpertsCountryDetails } from 'src/modules/experts/components/LocalExpertsCountryDetails';
import { LocalExpertsHeader } from 'src/modules/experts/components/LocalExpertsHeader';
import { LocalExpertsIntroduction } from 'src/modules/experts/components/LocalExpertsIntroduction';
import { useSpeakersRegionsQuery } from 'src/modules/experts/hooks/useSpeakersRegionsQuery';
import { ExpertsTemplate } from 'src/modules/experts/templates/ExpertsTemplate';

export const LocalExpertsTemplate = () => {
  const router = useRouter();

  const { data: regions } = useSpeakersRegionsQuery();

  const activeCountry = useMemo(
    () =>
      regions
        ?.flatMap((r) => r.countries)
        .find((c) => c.slug === router.query.country),
    [regions, router.query.country],
  );

  return (
    <ExpertsTemplate type="local" Header={LocalExpertsHeader}>
      {activeCountry ? (
        <LocalExpertsCountryDetails country={activeCountry} />
      ) : (
        <LocalExpertsIntroduction />
      )}
    </ExpertsTemplate>
  );
};
